import React from 'react'

const RsError = React.lazy(() => import('pages/RsError/RsError'));
const RsErrorAdd = React.lazy(() => import('pages/RsError/RsErrorAdd'));
const RsErrorEdit = React.lazy(() => import('pages/RsError/RsErrorEdit'));
const RsErrorDetail = React.lazy(() => import('pages/RsError/RsErrorDetail'));

const RsErrorRoutes = [
    {
        path: '/rs-error',
        exact: true,
        name: 'Danh sách lỗi máy',
        function: 'RS_ERROR_VIEW',
        component: RsError,
    },
    {
        path: '/rs-error/add',
        exact: true,
        name: 'Thêm mới lỗi máy',
        function: 'RS_ERROR_ADD',
        component: RsErrorAdd,
    },
    {
        path: '/rs-error/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'RS_ERROR_VIEW',
        component: RsErrorDetail,
    },
    {
        path: '/rs-error/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'RS_ERROR_EDIT',
        component: RsErrorEdit,
    },
]

export default RsErrorRoutes
